/**
 * The cold chain's paths.
 *
 * At the root rather than under `/admin`: this is an operations screen. The person who
 * needs it is the dispatcher who has to decide, right now, whether the pallet on the
 * lorry currently warming up can still be delivered.
 */

export const COLD_CHAIN_PATH = '/cold-chain'

export function coldChainVehiclePath(vehicleId: string): string {
  return `${COLD_CHAIN_PATH}?vehicle=${encodeURIComponent(vehicleId)}`
}
